module.exports = __webpack_public_path__ + "img/rubin_benefit_10_freetime.63cf1c18.svg";